<mat-toolbar
    role="banner"
    class="header-wrapper cipo-bg--primary-100"
    [class.menu-open]="!userStore.menu.isCollapsed()"
    [attr.data-testid]="'header-menu-is-open-' + !userStore.menu.isCollapsed()">
    <button
        mat-icon-button
        [class.menu-button-close]="!userStore.menu.isCollapsed()"
        [attr.aria-label]="
            (userStore.menu.isCollapsed() ? 'a11y.header.openMenu' : 'a11y.header.closeMenu') | translate
        "
        [attr.aria-expanded]="!userStore.menu.isCollapsed()"
        aria-controls="sidebar-menu"
        (click)="userStore.collapseMenu()"
        data-testid="sidebar-toggle">
        <mat-icon aria-hidden="true">{{ !userStore.menu.isCollapsed() ? "close" : "menu" }}</mat-icon>
    </button>
    <button type="button" class="logo-button" [attr.aria-label]="'a11y.header.logo' | translate" (click)="logoClick()">
        <img src="/src/assets/images/CIPO_logo.png" width="95" class="logo-wrapper" alt="" />
    </button>
    <div class="context-container">
        <cipo-context-view
            [context]="localContext()"
            (contextChange)="contextChanged($event)"
            (contextData)="contextDataLoaded($event)"></cipo-context-view>
    </div>
    <div fxLayout fxLayoutGap="12px" fxLayoutAlign="end center">
        <button
            (click)="toggleSearchOverlay('search')"
            mat-icon-button
            data-testid="header-search-button"
            [title]="'SEARCH_AI.ICON_PLACEHOLDER' | translate"
            [attr.aria-label]="'a11y.header.search' | translate"
            [attr.aria-expanded]="isSearchToggled()">
            <mat-icon class="material-symbols-outlined" [color]="isSearchToggled() ? 'accent' : ''" aria-hidden="true">
                search
            </mat-icon>
        </button>
        <button
            (click)="toggleSearchOverlay('cipo-ai')"
            mat-icon-button
            [title]="'CIPO_AI.TITLE' | translate"
            [attr.aria-label]="'a11y.header.cipoAI' | translate"
            [attr.aria-expanded]="isCipoAiToggled()">
            <mat-icon class="material-symbols-outlined" [color]="isCipoAiToggled() ? 'accent' : ''" aria-hidden="true">
                auto_awesome
            </mat-icon>
        </button>

        @if (canOpenContract()) {
            <button
                fxShow
                fxHide.lt-md
                mat-icon-button
                data-testid="header-contract-button"
                (click)="openContracts()"
                [title]="'header.editContract' | translate"
                [attr.aria-label]="'a11y.header.editContract' | translate">
                <mat-icon class="material-symbols-outlined" aria-hidden="true">contract_edit</mat-icon>
            </button>
        }
        @if (canOpenCorrespondence()) {
            <button
                fxShow
                fxHide.lt-md
                mat-icon-button
                (click)="goToCorrespondence()"
                [title]="'header.goToCorrespondence' | translate: { correspondence: correspondenceModule().name }"
                [attr.aria-label]="
                    (userStore.unreadNotifications()
                        ? 'a11y.header.correspondenceWithCount'
                        : 'a11y.header.goToCorrespondence'
                    ) | translate: { count: userStore.unreadNotifications() ?? 0 }
                ">
                <mat-icon
                    class="material-symbols-outlined"
                    [matBadge]="userStore.unreadNotifications()"
                    [matBadgeHidden]="!userStore.unreadNotifications()"
                    aria-hidden="true">
                    mail
                </mat-icon>
            </button>
        }

        <app-account-menu></app-account-menu>
    </div>
</mat-toolbar>

<cipo-search-overlay (toggleChange)="onToggleChange($event)"></cipo-search-overlay>
